import { add, isBefore, isValid, isSameDay, differenceInDays } from 'date-fns'
import { format, toZonedTime } from 'date-fns-tz'

export const useBooking = () => {
  const { link, accommodationsData } = useSetup();
  const destinations = useState('destinations', () => ({}))
  const booking = useState('booking', () => ({
    accommodation: {
      name: '',
      id: ''
    },
    dates: [],
    adults_count: 2,
    children: 0,
    duration_type: 'calendar',
    promo_code: '',
    children_age: [],
    duration: 'Weekend',
    month: 'May',
    date_from: '',
    date_to: '',
    rate_external_id: '',
    package_external_id: '',
    selected_units: [],
    loyalty_prices: true,
    selected_rate_name: '',
  }))
  const selectedAccommodationData = useState('selectedAccommodationData', () => ({}))
  const units = useState('units', () => ([]))
  const cancellationPolicies = useState('cancellationPolicies', () => ({}))
  const dateFormat = 'yyyy-MM-dd';
  // TODO: add logic for duration and month

  if(!Object.keys(destinations.value).length) setDestinations()
  if(!units.value.length) updateUnits();
  populateBooking()

  function populateBooking() {
    const router = useRouter().currentRoute.value;
    const query = JSON.parse(JSON.stringify(router.query))
    const sessionStorageBooking = JSON.parse(window?.sessionStorage?.getItem('booking') || '{}')

    booking.value = {
      ...booking.value,
      ...sessionStorageBooking,
    }

    for(const key in booking.value) {
      if(query[key] !== undefined) booking.value[key] = query[key]
    }

    let from = new Date(booking.value.date_from || booking.value.dates[0])
    let to = new Date(booking.value.date_to || booking.value.dates[1])
    const today = new Date()
    from = (!isValid(from) || isBefore(from, today)) ? today : from

    if (query.nights) {
      to = add(from, { days: parseInt(query.nights) || 1 })
    } else if(query.date_to || booking.value.date_to) {
      if (differenceInDays(to, from) > 90) {
        to = add(from, { days: 90 })
      } else {
        to = booking.value.date_to
        to = (!isValid(new Date(to)) || isBefore(new Date(to), from)) ? add(from, { days: 1 }) : new Date(to)
      }
    } else to = add(from, { days: 1 })

    from = format(toZonedTime(from, 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' });
    to = format(toZonedTime(to, 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' });
    booking.value.dates = [from, to]
    booking.value.date_from = from;
    booking.value.date_to = to;

    if (query.place_id) booking.value.accommodation = getByID('places', query.place_id)
    if (query.accommodation_id) {
      selectedAccommodationData.value = accommodationsData.value[query.accommodation_id]
      booking.value.accommodation = accommodationsData.value[query.accommodation_id]
    }
    if (booking.value.accommodation_id) booking.value.accommodation = accommodationsData.value[booking.value.accommodation_id]

    query.dates = booking.value.dates;
    query.date_from = booking.value.date_from;
    query.date_to = booking.value.date_to;
    // useRouter().replace({ query: { ...query } })

    for(const key of ['adults_count', 'children']) booking.value[key] = parseInt(booking.value[key])
    booking.value.children_age = Array.isArray(booking.value.children_age) ? Array.from(booking.value.children_age).map(i => !i ? 1 : parseInt(i)) : [parseInt(booking.value.children_age)]
  }

  if(import.meta.client) sessionStorage.setItem('booking', JSON.stringify(booking.value))

  function setDestinations() {
    const { initialData: { value: { destinations: _destinations, accommodation_kind_groups: accommodationKindGroups }} } = useSetup()

    const hotelIdentificators = accommodationKindGroups.find(item => item.items.includes('HOTEL')).items;
    const obj = {}
    const places = []
    for(const item of _destinations) {
      for(const region of item.regions) {
        for(const place of region.places) {
          places.push(place)
          for(const accommodation of place.accommodations) {
            if(!obj[accommodation.type]) obj[accommodation.type] = []
            obj[accommodation.type].push({ accommodation, location: place })
          }
        }
      }
    }

    destinations.value.hotels = Object.values(obj).flat().filter(item => hotelIdentificators.includes(item?.accommodation?.type))
    destinations.value.camps = Object.values(obj).flat().filter(item => !hotelIdentificators.includes(item?.accommodation?.type))
    destinations.value.places = places
    destinations.value.accommodations = Object.values(obj).flat()
  }

  function getByID(list, id, childItem) {
    return destinations.value?.[list]?.find(i => childItem ? parseInt(i[childItem].id) === parseInt(id) : i.id === parseInt(id))
  }

  async function submitSearchData() {
    let template = '';
    if (booking.value.place_id && booking.value.accommodation?.accommodation_location) {
      template = 'AccommodationLocationLink';
      await navigateTo(booking.value.accommodation?.accommodation_location);
      return template;
    } else {
      template = booking.value.place_id ? 'AccommodationList' : 'AccommodationUnitList'
      constructAndUpdateQuery(link(template))
      return template;
    }
  }

  function constructQuery() {
    const query = {}
    for(const key in booking.value) {
      const value = booking.value[key]
      if(typeof value !== 'object' || Array.isArray(value) || isValid(booking.value[key])) query[key] = value
    }
    return query;
  }

  function updateUnits() {
    if (Array.isArray(booking.value.selected_units)) {
      units.value = [];
      for (let unit of booking.value.selected_units) {
        units.value.push({
          external_id: unit,
          adults_count: booking.value.adults_count,
          children_age: booking.value.children_age,
          services: [],
        })
      }
    } else {
      if (!units.value.includes(booking.value.selected_units)) {
        units.value = [{
          external_id: booking.value.selected_units,
          adults_count: booking.value.adults_count,
          children_age: booking.value.children_age,
          services: [],
        }];
      }
    }

    if (import.meta.client) sessionStorage.setItem('units', JSON.stringify(units.value))
  }

  function updateStorage() {
    if(import.meta.client) sessionStorage.setItem('booking', JSON.stringify(booking.value))
  }

  function constructAndUpdateQuery(url) {
    const { path } = useRoute()
    useRouter()[url ? 'push' : 'replace']({ path: url || path, query: { ...useRoute().query, ...(constructQuery() || {}) } })
  }

  watch(booking, updateStorage, { deep: true })

  return {
    booking,
    units,
    destinations,
    cancellationPolicies,
    selectedAccommodationData,

    constructAndUpdateQuery,
    getByID,
    updateUnits,
    populateBooking,
    constructQuery,
    submitSearchData,
  }
}